import { createContext, useContext } from 'react';

export type ZyVersionFilterContextValue = {
    setVersionFilterLoading: (loading: boolean) => void;
};

export const ZyVersionFilterContext = createContext<ZyVersionFilterContextValue>({
    setVersionFilterLoading: () => {},
});

export function useZyVersionFilterContext(): ZyVersionFilterContextValue {
    return useContext(ZyVersionFilterContext);
}
